export enum DocumentStatus {
  JAUNS = 'JAUNS',
  APSTIPRINĀTS = 'APSTIPRINĀTS',
  NORAIDĪTS = 'NORAIDĪTS',
}
